var _circle, _line, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBridgeupDilution = function SvgBridgeupDilution(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 77,
    fill: "url(#paint0_linear_3666_2844)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 76,
    x2: 153,
    y2: 76,
    stroke: "url(#paint1_linear_3666_2844)",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3666_2844",
    x1: 26.4937,
    y1: 2.83786e-7,
    x2: 141,
    y2: 214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38EF7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3666_2844",
    x1: 170.344,
    y1: 77.5116,
    x2: 52.3019,
    y2: 77.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1340B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2455D5"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBridgeupDilution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bridgeup-dilution.09bab20b.svg";
export { ForwardRef as ReactComponent };